import Masonry from "react-masonry-css";
import { Gallery, Item } from "react-photoswipe-gallery";
import { Link } from "react-router-dom";
import { CardBody } from "reactstrap";
import { H4, LI, P } from "../../../AbstractElements";
import { Href, Imagedesc, PortfolioTitle } from "../../../Constant";
import { MASONARY_IMAGE_DATA } from "../../../Data/Gallery";
import { dynamicImage } from "../../../Service/DynamicImage";

export const MasonryGalleryWithDescriptionCardBody = () => {
  const breakpointColumnsObj = {
    default: 4,
    1199: 3,
    700: 2,
    500: 1,
  };

  return (
    <CardBody className="photoswipe-pb-responsive me-3">
      <Gallery>
        <Masonry breakpointCols={breakpointColumnsObj} className="my-gallery row grid gallery-with-description" columnClassName="grid-item col-xl-3 col-sm-6">
          {MASONARY_IMAGE_DATA.map((element, index) => (
            <LI style={{ listStyle: "none" }} key={index} className="p-0">
              <figure className="m-0">
                <Item original={dynamicImage(element.src)} width="1300" height="750">
                  {({ ref, open }) => (
                    <Link to={Href} onClick={open}>
                      <img className="img-thumbnail p-2 rounded-0 rounded-top-1" ref={ref} src={dynamicImage(element.src)} alt="images" />
                      <div className="caption border-top-0 p-2">
                        <H4 className="mt-0">{PortfolioTitle}</H4>
                        <P>{Imagedesc}</P>
                      </div>
                    </Link>
                  )}
                </Item>
              </figure>
            </LI>
          ))}
        </Masonry>
      </Gallery>
    </CardBody>
  );
};
